async function i(a) {
  navigator.clipboard && await navigator.clipboard.writeText(a);
}
export {
  i as copyToClipboard
};
